import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Layout, Form, Input, Select, PageHeader, Tabs, Table, AutoComplete, Button, Divider, Spin, message } from 'antd';

import emitter from '../Evt.js';

const { Content } = Layout;
const { TabPane } = Tabs;
const { Option } = AutoComplete;
const Options = Select.Option;

var languageMessages = window.appLocale.messages;

class IndexPage extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            spinLoadding: true,

            tDataSource: [],
            cDataSource: [],
            sDataSource: [],

            symbolCode: '',
            symbolName: '',

            dayline: '1',
            min60line: '1',

            dayline01: '',
            dayline02: '',
            min60line01: '',
            min60line02: '',

            symbolStatus: '',
            symbolMessage: '',

            daylineMode: 0,
            min60lineMode: 0,

            sectorItems: [],
            symbolItems: [],

            currentSelectKey: '',

            sactorCategoryRowId: '-1',
            sactorRowId: '-1',
            
        };
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
    }

    init = () => {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        /**
        if (user.username === undefined) {
            this.setState({ spinLoadding: false }, () => {
                this.props.dispatch({ type: "action_non_user" });
            });
        } else {
            
        }
        */
        this.props.dispatch({ type: "action_region_sector", payload: { UserId: this.user.username } });
    }

    componentWillReceiveProps(props) {
        var { status, state, sectorItems, symbolItems } = props;

        switch (status) {
            case 'get_region_sector_success':
                sectorItems = sectorItems === undefined || sectorItems === null ? [] : sectorItems;

                var tDataSource = [];
                var cDataSource = [];
                var sDataSource = [];

                var sactorRowId = '-1';
                var sactorCategoryRowId = '-1'
                var currentSelectKey = '2';
                if (sectorItems.length > 0) {
                    let tmpSectorItems = sectorItems[0];
                    currentSelectKey = tmpSectorItems.id;
                    currentSelectKey = currentSelectKey.toString();

                    var index = 1;
                    var sectorList = tmpSectorItems.rs === undefined || tmpSectorItems.rs === null ? [] : tmpSectorItems.rs;
                    for (var i = 0; i < sectorList.length; i++) {
                        if (i === 0) {
                            var subIndex = 1;
                            var tmpSymbols = sectorList[i].s;
                            for (var j = 0; j < tmpSymbols.length; j++) {
                                if (j === 0) {
                                    sactorRowId = subIndex;
                                }
                                cDataSource.push({
                                    key: subIndex,
                                    sequence: subIndex,
                                    stockCode: tmpSymbols[j],
                                    quoteChange: 1.8,
                                });

                                subIndex++;
                            }

                            sactorCategoryRowId = sectorList[i].id;
                        }

                        tDataSource.push({
                            key: sectorList[i].id,
                            sequence: index,
                            name: sectorList[i].n,
                            quoteChange: 1.8,
                            volumeRatio: 1.5,
                            riseSpeed: 0.1,
                            riseNumber: 10,
                            fallNumber: 20,
                            tradeAmount: 1000,
                            increase5day: 10,
                            increase10day: 20,
                            increase20day: 20,
                        });

                        index++;
                    }
                }

                this.setState({ sectorItems, tDataSource, cDataSource, currentSelectKey, sactorCategoryRowId, sactorRowId, spinLoadding: false }, () => {
                    var record = tDataSource[0]
                    var tmpRecord = tDataSource.filter(function (n) { return n.key === sactorCategoryRowId });
                    if (tmpRecord.length > 0) {
                        record = tmpRecord[0];
                    }
                    this.setRowClassName(record);

                    record = cDataSource[0];
                    tmpRecord = cDataSource.filter(function (n) { return n.key === sactorRowId });
                    if (tmpRecord.length > 0) {
                        record = tmpRecord[0];
                    }

                    this.setSymbolRowClassName(record);
                });
                break;
            case 'get_region_sector_fail':
                var error = languageMessages['get.data.failed'];
                switch (state) {
                    case 0:
                        break;
                    case 2:
                        error = languageMessages['user.exception'];
                        break;
                    default:
                        break;
                }
                message.error(error);
                this.setState({ spinLoadding: false });
                break;
            case 'get_symbol_items_success':
                var symbolItems = symbolItems;
                if (symbolItems !== undefined && symbolItems.length > 0) {
                    this.setState({ symbolItems });
                } else {
                    if (this.state.keywords !== '') {
                        this.setState({ symbolItems: [{ symbol: '"' + this.state.keywords + '"' + languageMessages['no.matches.found'], symbolName: '' }] });
                    } else {
                        this.setState({
                            symbolItems: []
                        });
                    }
                }
                break;
            default:
                break;
        }
    }

    onChangeSymbol = (symbolCode) => {
        this.setState({ symbolCode });
    }

    // 匹配标的
    handleSearch = value => {
        this.setState({ keywords: value }, () => {
            /**
            if (this.user.username === undefined) {
                this.props.dispatch({ type: "action_non_user" });
            } else {
                this.props.dispatch({ type: "action_get_symbol_items", payload: { UserId: this.user.username, keywords: value } });
            }
            */
            this.props.dispatch({ type: "action_get_symbol_items", payload: { UserId: this.user.username, keywords: value } });
        });
    };

    // 选择标的
    onSelectSymbol = value => {
        if (value !== '') {
            if (value.search(languageMessages['no.matches.found']) === -1) {
                //languageMessages['no.matches.found']

                //var symbolItems = JSON.parse(sessionStorage.getItem("SymbolItemsCache") || '[]') || [];
                //var tmpDataCode = symbolItems.filter(function (e) { return e.stockCode.toLowerCase() === value.toLowerCase(); });
                var tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.toLowerCase() === value.toLowerCase(); });

                if (tmpDataCode.length > 0) {
                    var symbolCode = tmpDataCode[0].symbol;
                    var symbolName = tmpDataCode[0].symbolName;

                    this.setState({ symbolCode, symbolName });
                }
            }
        }
    }

    onFocusSymbol = () => {
        // defaylt symbol items
    }

    onBlurSymbol = value => {
        if (value !== '') {
            var tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.toLowerCase() === value.toLowerCase(); });

            if (tmpDataCode.length === 0) {
                tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.substring(2, e.symbol.length) === value; });
            }

            if (tmpDataCode.length === 1) {
                var symbolCode = tmpDataCode[0].symbol;
                var symbolName = tmpDataCode[0].symbolName;

                this.setState({ symbolCode, symbolName });
            } else {
                this.setState({
                    symbolItems: [],
                    symbolCode: '',
                    symbolName: '',
                });
            }
        } else {
            this.setState({
                symbolItems: [],
                symbolCode: '',
                symbolName: '',
            });
        }
    }

    handleDayLineChange = value => {
        let dayline = value.key;
        let daylineMode = dayline === '0' ? 1 : 0;
        this.setState({ dayline, daylineMode });
    }

    handleMin60LineChange = value => {
        let min60line = value.key;
        let min60lineMode = min60line === '0' ? 1 : 0;
        this.setState({ min60line, min60lineMode });
    }

    handleDayLineBack = () => {
        this.setState({ dayline: '1', daylineMode: 0 });
    }

    handleMin60lineModeBack = () => {
        this.setState({ min60line: '1', min60lineMode: 0 });
    }

    handleNumberChange = e => {
        let intLen = 1;
        let decimalLen = 2;

        var less = '';
        var number = e.target.value;
        var n = number.match("^-");
        if (n !== null && n.length > 0) {
            less = n[0];
        }

        if (number.indexOf('.') === 0) {
            number = number.replace(/[^\d]/g, "");
        }
        number = number.replace(/[^\d.]/g, "");
        number = number.replace(/\.{2,3}/g, ".");
        number = number.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");

        if (number.indexOf('.') < 0) {
            if (number.length > intLen) number = number.slice(0, intLen);

            if (number !== '') number = parseInt(number);
            if (number > 1) number = 1;
        } else {
            var tmpNumber = number.split('.');
            var tmpNum00 = tmpNumber[0];
            if (tmpNum00.length > intLen) tmpNum00 = tmpNum00.slice(0, intLen);

            if (tmpNum00 !== '') tmpNum00 = parseInt(tmpNum00);
            if (tmpNum00 > 1) tmpNum00 = 1;

            var tmpNum01 = tmpNumber[1];
            if (tmpNum01.length > decimalLen) tmpNum01 = tmpNum01.slice(0, decimalLen);
            if (tmpNum00 === 1) {
                var len = tmpNum01.length;
                if (len === 2) {
                    number = tmpNum00 + '.00';
                } else if (len === 1) {
                    number = tmpNum00 + '.0';
                } else {
                    number = tmpNum00;
                }
            } else {
                number = tmpNum00 + '.' + tmpNum01;
            }
        }

        let tags = e.target.getAttribute('data-value');
        var tmpParams = {};
        tmpParams[tags] = less + '' + number;
        this.setState(tmpParams);
    };

    onBlurNumberChange = e => {
        e.preventDefault();

        var number = e.target.value;
        if (number.length > 0) {
            if (number.indexOf('.') < 0) {
                if (number === '-') number = '-0';
                number = number + '.00';
            } else {
                var tmpValue = number.split('.');
                var len = tmpValue[1].length;
                if (len === 0) {
                    number = number + '00';
                } else if (len === 1) {
                    number = number + '0';
                }
            }
        }

        let tags = e.target.getAttribute('data-value');
        var tmpParams = {};
        tmpParams[tags] = number;
        this.setState(tmpParams);
    }

    setRowClassName = (record) => {
        if (record === undefined) return '';
        return record.key.toString() === this.state.sactorCategoryRowId.toString() ? 'common-table-row' : '';
    }

    setSymbolRowClassName = (record) => {
        if (record === undefined) return '';
        return record.key.toString() === this.state.sactorRowId.toString() ? 'common-table-row' : '';
    }

    selectSactorCategoryRow = (record) => {
        let { currentSelectKey } = this.state;
        
        let sactorCategoryRowId = record.key.toString();
        let sactorRowId = '-1';
        this.getDatabase(currentSelectKey, sactorCategoryRowId, sactorRowId);
    }

    selectSactorRow = (record) => {
        let { currentSelectKey, sactorCategoryRowId } = this.state;
        
        let sactorRowId = record.key.toString();

        this.getDatabase(currentSelectKey, sactorCategoryRowId, sactorRowId);
    }

    handleChangeSector = (currentSelectKey) => {
        let sactorCategoryRowId = '-1';
        let sactorRowId = '-1';
        this.getDatabase(currentSelectKey, sactorCategoryRowId, sactorRowId);
    }

    getDatabase(currentSelectKey, sactorCategoryRowId, sactorRowId) {
        let { sectorItems } = this.state;
        // 切换数据

        var tDataSource = [];
        var cDataSource = [];
        var sDataSource = [];

        var items = sectorItems.filter(function (v) { return v.id === parseInt(currentSelectKey) });

        if (items.length > 0) {
            let tmpSectorItems = items[0];
            currentSelectKey = tmpSectorItems.id;
            currentSelectKey = currentSelectKey.toString();

            var index = 1;
            var sectorList = tmpSectorItems.rs === undefined || tmpSectorItems.rs === null ? [] : tmpSectorItems.rs;
            for (var i = 0; i < sectorList.length; i++) {
                if (sactorCategoryRowId === '-1') sactorCategoryRowId = sectorList[i].id;

                if (sectorList[i].id === parseInt(sactorCategoryRowId)) {
                    var subIndex = 1;
                    var tmpSymbols = sectorList[i].s;
                    for (var j = 0; j < tmpSymbols.length; j++) {
                        if (sactorRowId === '-1') sactorRowId = subIndex;

                        cDataSource.push({
                            key: subIndex,
                            sequence: subIndex,
                            stockCode: tmpSymbols[j],
                            quoteChange: 1.8,
                        });

                        subIndex++;
                    }
                }

                tDataSource.push({
                    key: sectorList[i].id,
                    sequence: index,
                    name: sectorList[i].n,
                    quoteChange: 1.8,
                    volumeRatio: 1.5,
                    riseSpeed: 0.1,
                    riseNumber: 10,
                    fallNumber: 20,
                    tradeAmount: 1000,
                    increase5day: 10,
                    increase10day: 20,
                    increase20day: 20,
                });

                index++;
            }
        }

        this.setState({ tDataSource, cDataSource, currentSelectKey, sactorCategoryRowId, sactorRowId }, () => {
            var record = tDataSource[0]
            var tmpRecord = tDataSource.filter(function (n) { return n.key === sactorCategoryRowId });
            if (tmpRecord.length > 0) {
                record = tmpRecord[0];
            }
            this.setRowClassName(record);

            record = cDataSource[0];
            tmpRecord = cDataSource.filter(function (n) { return n.key === sactorRowId });
            if (tmpRecord.length > 0) {
                record = tmpRecord[0];
            }
            this.setSymbolRowClassName(record);
        });
    }

    renderOption = (group) => {
        return <Option key={group.symbol} value={group.symbol}>
                {group.symbol}
                <span className="certain-search-item-count">{group.symbolName}</span>
            </Option>
    }

    render() {
        var { tDataSource, cDataSource, sDataSource, symbolItems, symbolCode } = this.state;

        if (symbolCode.search(languageMessages['no.matches.found']) !== -1) {
            symbolCode = symbolCode.replace(languageMessages['no.matches.found'], '');
            symbolCode = symbolCode.substring(1, symbolCode.length - 1);
        }

        let tColumns = [];
        let cColumns = [];
        let sColumns = [];

        let sequence = {
            title: languageMessages['sequence'],
            dataIndex: 'sequence',
            width: 50,
            fixed: 'left',
        }

        tColumns.push(sequence);
        cColumns.push(sequence);
        sColumns.push(sequence);

        let name = {
            title: '名称',
            dataIndex: 'name',
            width: 150,
            sorter: (a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0,
            sortDirections: ['descend', 'ascend'],
            fixed: 'left',
        };

        let stockcode = {
            title: languageMessages['symbol.code'],
            dataIndex: 'stockCode',
            width: 120,
            sorter: (a, b) => a.stockCode < b.stockCode ? -1 : a.stockCode > b.stockCode ? 1 : 0,
            sortDirections: ['descend', 'ascend'],
            fixed: 'left',
        };

        let stockname = {
            title: languageMessages['symbol.name'],
            dataIndex: 'stockName',
            width: 120,
            sorter: (a, b) => a.stockName < b.stockName ? -1 : a.stockName > b.stockName ? 1 : 0,
            sortDirections: ['descend', 'ascend'],
            fixed: 'left',
        };

        let overallrating = {
            title: '综合评分',
            dataIndex: 'overallRating',
            width: 100,
            sorter: (a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0,
            sortDirections: ['descend', 'ascend'],
            fixed: 'left',
        };

        let corrcoefficient = {
            title: '相关系数',
            dataIndex: 'corrCoefficient',
            width: 100,
            sorter: (a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0,
            sortDirections: ['descend', 'ascend'],
            fixed: 'left',
        };
        let quotechange = {
            title: languageMessages['quote.change'],
            dataIndex: 'quoteChange',
            sorter: (a, b) => a.quoteChange - b.quoteChange,
            align: 'right',
            sortDirections: ['descend', 'ascend'],
            render: (text) => {
                if (text >= 0) {
                    return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}%</span>;
                } else {
                    return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}%</span>;
                }
            },
        };
        let latest = {
            title: languageMessages['latest.price'],
            dataIndex: 'price',
            sorter: (a, b) => a.price - b.price,
            align: 'right',
            sortDirections: ['descend', 'ascend'],
            render: (text, row) => {
                return <span>{text}</span>;
            },
        };

        let risefall = {
            title: '涨跌',
            dataIndex: 'riseFall',
            sorter: (a, b) => a.riseFall - b.riseFall,
            sortDirections: ['descend', 'ascend'],
        };

        let volumeratio = {
            title: '量比',
            dataIndex: 'volumeRatio',
            sorter: (a, b) => a.volumeRatio - b.volumeRatio,
            sortDirections: ['descend', 'ascend'],
        };
        let risespeed = {
            title: '涨速',
            dataIndex: 'riseSpeed',
            sorter: (a, b) => a.riseSpeed - b.riseSpeed,
            sortDirections: ['descend', 'ascend'],
        };
        let risenumber = {
            title: '涨家数',
            dataIndex: 'riseNumber',
            sorter: (a, b) => a.riseNumber - b.riseNumber,
            sortDirections: ['descend', 'ascend'],
        };
        let fallnumber = {
            title: '跌家数',
            dataIndex: 'fallNumber',
            sorter: (a, b) => a.fallNumber - b.fallNumber,
            sortDirections: ['descend', 'ascend'],
        };
        let tradeamount = {
            title: '成交额',
            dataIndex: 'tradeAmount',
            sorter: (a, b) => a.tradeAmount - b.tradeAmount,
            sortDirections: ['descend', 'ascend'],
        };

        let increase5day = {
            title: '5日涨幅',
            dataIndex: 'increase5day',
            sorter: (a, b) => a.increase5day - b.increase5day,
            sortDirections: ['descend', 'ascend'],
            render: (text) => {
                if (text >= 0) {
                    return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}%</span>;
                } else {
                    return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}%</span>;
                }
            },
        };

        let increase10day = {
            title: '10日涨幅',
            dataIndex: 'increase10day',
            sorter: (a, b) => a.increase10day - b.increase10day,
            sortDirections: ['descend', 'ascend'],
            render: (text) => {
                if (text >= 0) {
                    return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}%</span>;
                } else {
                    return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}%</span>;
                }
            },
        };

        let increase20day = {
            title: '20日涨幅',
            dataIndex: 'increase20day',
            sorter: (a, b) => a.increase20day - b.increase20day,
            sortDirections: ['descend', 'ascend'],
            render: (text) => {
                if (text >= 0) {
                    return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}%</span>;
                } else {
                    return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}%</span>;
                }
            },
        };

        let totalmarketvalue = {
            title: '总市值',
            dataIndex: 'totalMarketValue',
            sorter: (a, b) => a.totalMarketValue - b.totalMarketValue,
            sortDirections: ['descend', 'ascend'],
        };

        let circulationmarketvalue = {
            title: '流通市值',
            dataIndex: 'circulationMarketValue',
            sorter: (a, b) => a.circulationMarketValue - b.circulationMarketValue,
            sortDirections: ['descend', 'ascend'],
        };
        
        let turnoverrate = {
            title: '换手率%',
            dataIndex: 'turnoverRate',
            sorter: (a, b) => a.turnoverRate < b.turnoverRate,
            sortDirections: ['descend', 'ascend'],
        };

        let amplitude = {
            title: '振幅%',
            dataIndex: 'amplitude',
            sorter: (a, b) => a.amplitude < b.amplitude,
            sortDirections: ['descend', 'ascend'],
        };

        let PERatio = {
            title: '市盈率(动)',
            dataIndex: 'PERatio',
            sorter: (a, b) => a.PERatio - b.PERatio,
            sortDirections: ['descend', 'ascend'],
        };

        let tallest = {
            title: '最高',
            dataIndex: 'tallest',
            sorter: (a, b) => a.tallest - b.tallest,
            sortDirections: ['descend', 'ascend'],
        };

        let lowest = {
            title: '最低',
            dataIndex: 'lowest',
            sorter: (a, b) => a.lowest - b.lowest,
            sortDirections: ['descend', 'ascend'],
        };


        sColumns.push(stockcode);
        sColumns.push(stockname);
        sColumns.push(overallrating);
        sColumns.push(corrcoefficient);
        sColumns.push(quotechange);
        sColumns.push(latest);
        sColumns.push(risefall);
        sColumns.push(volumeratio);
        sColumns.push(risespeed);
        sColumns.push(tradeamount);
        sColumns.push(increase5day);
        sColumns.push(increase10day);
        sColumns.push(increase20day);
        sColumns.push(totalmarketvalue);
        sColumns.push(circulationmarketvalue);
        sColumns.push(turnoverrate);
        sColumns.push(amplitude);
        sColumns.push(PERatio);
        sColumns.push(tallest);
        sColumns.push(lowest);


        

        let tmpquotechange = {
            title: languageMessages['quote.change'],
            dataIndex: 'quoteChange',
            sorter: (a, b) => a.quoteChange - b.quoteChange,
            align: 'right',
            width: 100,
            sortDirections: ['descend', 'ascend'],
            render: (text) => {
                if (text >= 0) {
                    return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}%</span>;
                } else {
                    return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}%</span>;
                }
            },
            fixed: 'left',
        };
        let tmplatest = {
            title: languageMessages['latest.price'],
            dataIndex: 'price',
            sorter: (a, b) => a.price - b.price,
            align: 'right',
            width: 100,
            sortDirections: ['descend', 'ascend'],
            render: (text, row) => {
                return <span>{text}</span>;
            },
            fixed: 'left',
        };

        tColumns.push(name);
        
        tColumns.push(tmpquotechange);

        tColumns.push(volumeratio);
        tColumns.push(risespeed);
        tColumns.push(risenumber);
        tColumns.push(fallnumber);
        tColumns.push(tradeamount);
        tColumns.push(increase5day);
        tColumns.push(increase10day);
        tColumns.push(increase20day);


        cColumns.push(stockcode);
        cColumns.push(stockname);

        cColumns.push(tmpquotechange);
        cColumns.push(tmplatest);

        cColumns.push(risefall);
        cColumns.push(volumeratio);
        cColumns.push(risespeed);
        cColumns.push(tradeamount);
        cColumns.push(increase5day);
        cColumns.push(increase10day);
        cColumns.push(increase20day);
        cColumns.push(totalmarketvalue);
        cColumns.push(circulationmarketvalue);
        cColumns.push(turnoverrate);
        cColumns.push(amplitude);
        cColumns.push(PERatio);
        cColumns.push(tallest);
        cColumns.push(lowest);

        //var sector = [{ 'id': 2, 'name': '概念' }, { 'id': 5, 'name': '证监会行业' }, { 'id': 7, 'name': '指数板块'}];

        return (<Content className='main-container'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
            <div className='common-page-header'>
                <PageHeader title={(<h1>{languageMessages['correlation.query']}</h1>)} />
            </div>
            <Layout className='main-tabs-content'>
                <div className='common-title'><Divider type="vertical" />{'沪深市场'}</div>
                        
                <div className="card-container common-tabs">
                    <Tabs activeKey={this.state.currentSelectKey} type="card" onChange={this.handleChangeSector}>
                        {this.state.sectorItems.map(item => (
                        <TabPane tab={`${item.n}`} key={`${item.id}`}>
                            <Table bordered size='small'
                                columns={tColumns}
                                dataSource={tDataSource}
                                rowClassName={this.setRowClassName}
                                onRow={(record) => ({
                                    onClick: () => {
                                        this.selectSactorCategoryRow(record);
                                    },
                                })} scroll={{ x: 950 }} pagination={{ defaultPageSize: 8 }} />

                            <div className='common-title'>{'注册制次新股   板块共有 35 只个股'}</div>

                            <Table bordered size='small'
                                columns={cColumns}
                                dataSource={cDataSource}
                                rowClassName={this.setSymbolRowClassName}
                                onRow={(record) => ({
                                    onClick: () => {
                                        this.selectSactorRow(record);
                                    },
                                })} scroll={{ x: 1950 }} pagination={{ defaultPageSize: 8 }} />
                        </TabPane>
                        ))}
                    </Tabs>
                </div>

                <div className='common-title'><Divider type="vertical" />{'相关性查询'}</div>
                <div>

                    <Form labelAlign={'left'} layout="inline">
                        <Form.Item colon={false} label={languageMessages['symbolCode']} validateStatus={this.state.symbolStatus} help={this.state.symbolMessage} style={{ marginBottom: 0, marginRight: 32 }}>
                            <AutoComplete value={symbolCode}
                                className="certain-category-search"
                                dropdownClassName="certain-category-search-dropdown"
                                dropdownMatchSelectWidth={false}
                                dropdownStyle={{ width: 200 }}
                                size="small"
                                style={{ width: '200px' }}
                                dataSource={symbolItems.map(this.renderOption)}
                                onChange={this.onChangeSymbol}
                                onSearch={this.handleSearch}
                                onSelect={this.onSelectSymbol}
                                onFocus={this.onFocusSymbol}
                                onBlur={this.onBlurSymbol}
                                placeholder={languageMessages['pleaseEnterStockName-Symbol']}
                                optionLabelProp="value">
                            </AutoComplete>
                        </Form.Item>
                        <Form.Item colon={false} style={{ marginBottom: 0 }}>
                            <b>{'相关性'}</b>
                        </Form.Item>
                        <Form.Item colon={false} label={'日线'} validateStatus={this.state.tradeQuantityStatus} help={this.state.tradeQuantityMessage} style={{ marginBottom: 0, marginRight: 32 }}>
                            <div style={{ display: this.state.daylineMode === 0 ? '' : 'none' }}>
                                <Select labelInValue size='small' style={{ width: '120px' }} value={{ key: this.state.dayline }}
                                    onChange={this.handleDayLineChange}>
                                    <Options key='1'>{'高度正相关'}</Options>
                                    <Options key='2'>{'高度负相关'}</Options>
                                    <Options key='3'>{'低度相关'}</Options>
                                    <Options key='4'>{'不相关'}</Options>
                                    <Options key='0'>{'自定义相关性'}</Options>
                                </Select>
                            </div>
                            <div style={{ display: this.state.daylineMode === 0 ? 'none' : '' }}>
                                <Input size="small" style={{ width: 80 }} value={this.state.dayline01} data-value='dayline01' onChange={this.handleNumberChange} onBlur={this.onBlurNumberChange} />
                                <span style={{ padding:'0 10px' }}>至</span>
                                <Input size="small" style={{ width: 80 }} value={this.state.dayline02} data-value='dayline02' onChange={this.handleNumberChange} onBlur={this.onBlurNumberChange} />
                                <span style={{ padding: '0 5px' }}></span>
                                <Button size="small" onClick={this.handleDayLineBack}>{'返回'}</Button>
                            </div>
                        </Form.Item>
                        <Form.Item colon={false} label={'60分钟线'} validateStatus={this.state.tradeDateStatus} help={this.state.tradeDateMessage}>
                            <div style={{ display: this.state.min60lineMode === 0 ? '' : 'none' }}>
                                <Select labelInValue size='small' style={{ width: '120px' }} value={{ key: this.state.min60line }}
                                    onChange={this.handleMin60LineChange}>
                                    <Options key='1'>{'高度正相关'}</Options>
                                    <Options key='2'>{'高度负相关'}</Options>
                                    <Options key='3'>{'低度相关'}</Options>
                                    <Options key='4'>{'不相关'}</Options>
                                    <Options key='0'>{'自定义相关性'}</Options>
                                </Select>
                            </div>
                            <div style={{ display: this.state.min60lineMode === 0 ? 'none' : '' }}>
                                <Input size="small" style={{ width: 80 }} value={this.state.min60line01} data-value='min60line01' onChange={this.handleNumberChange} onBlur={this.onBlurNumberChange} />
                                <span style={{ padding: '0 10px' }}>至</span>
                                <Input size="small" style={{ width: 80 }} value={this.state.min60line02} data-value='min60line02' onChange={this.handleNumberChange} onBlur={this.onBlurNumberChange} />
                                <span style={{ padding: '0 5px' }}></span>
                                <Button size="small" onClick={this.handleMin60lineModeBack}>{'返回'}</Button>
                            </div>
                        </Form.Item>
                    </Form>
                    <div style={{ padding: '0', height: '40px' }}>
                        <Button size='small' onClick={this.handleSubmit} disabled={true}>
                            {'查询'}
                        </Button>
                    </div>
                </div>

                <div className='common-title'>{'根据设置，共查询到 2 只股票'}</div>
                <Table bordered size='small'
                    columns={sColumns}
                    dataSource={sDataSource}
                    scroll={{ x: 2150 }} pagination={{ defaultPageSize: 8 }} />
            </Layout>
        </Spin>
    </Content>)
    }
}

function mapStateToProps(state) {
    return state.correlation;
}

const page = connect(mapStateToProps)(IndexPage);
export { page as default }